import CallbackLoading from '../../components/CallbackLoading';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import useSharedPostApi from '../../lib/useSharedPostApi.js';
import * as Toast from '../../lib/Toast.js';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import { setBusinessId } from '../../lib/Api';
import PageContainer from '../components/PageContainer.jsx';
import { useHandlePaymentReturnResponse } from '~/public/lib/Payments';
import ErrorPage from '~/pages/ErrorPage.jsx';
import * as Sentry from '@sentry/react';
import ErrorMessageBlock from '~/components/ErrorMessageBlock.jsx';
import {
    FormPaymentFormWithSavedParams,
    hasSavedPaymentParams,
} from '~/public/components/FormPaymentFormWithSavedParams.jsx';
import { sendScrollTop } from '~/public/lib/EmbedMessaging.js';

const HandlePayment = ({ businessId, type, id, setError }) => {
    setBusinessId(businessId);
    const { save, isSaving } = useSharedPostApi(
        `/payments/payment-complete/${businessId}/${type}/${id}`,
    );

    const { handleResponse } = useHandlePaymentReturnResponse();

    const params = new URL(document.location).searchParams;
    const hasFired = useRef(false);

    useEffect(() => {
        if (hasFired.current) return;
        hasFired.current = true;

        const start = new Date();
        sendScrollTop();
        save({
            payment_intent:
                params.get('payment_intent') || params.get('setup_intent'),
            redirect_status: params.get('redirect_status'),
            params: params.get('params'), // keep passing 'em along...
        })
            .then(result => {
                handleResponse(result);
            })
            .catch(err => {
                const message = err.response?.data?.message;
                setError(
                    `Failed to process payment, please try again. ${message}`,
                );
                const duration = new Date() - start;
                let extraData = '';
                try {
                    extraData = JSON.stringify(err.response?.data);
                } catch (e) {
                    // ignore
                }

                Sentry.captureMessage(
                    `Failed to process payment: ${message} [${duration}ms]: ${extraData}`,
                );
            });
    }, []);

    return null;
};

const PaymentsReturnPage = ({}) => {
    const { businessId, type, id } = useParams();
    const [error, setError] = useState(null);

    const showPaymentForm =
        !!error &&
        type.indexOf('formsubmission') >= 0 &&
        hasSavedPaymentParams() &&
        // Ok, this is a little flakey, but it's better than nothing
        //  for a few errors we don't want to show the payment form, like if a time is no longer available
        error.indexOf('no longer available') < 0;

    return (
        <Sentry.ErrorBoundary
            fallback={({ eventId }) => <ErrorPage eventId={eventId} />}
        >
            {showPaymentForm && (
                <FormPaymentFormWithSavedParams error={error} />
            )}
            {!showPaymentForm && (
                <PageContainer hidePoweredBy={true}>
                    <CallbackLoading
                        error={error}
                        message="Please wait, processing payment. This is not yet complete, please leave the page open..."
                    >
                        <HandlePayment
                            businessId={businessId}
                            type={type}
                            id={id}
                            setError={setError}
                        />
                    </CallbackLoading>
                </PageContainer>
            )}
        </Sentry.ErrorBoundary>
    );
};

export default PaymentsReturnPage;
